import { Icon } from "semantic-ui-react";

const cellValue = (entHeader, entData, handleIconclick) => {
  const data = entData[entHeader.header];
  switch (entHeader.type) {
    case "datetime":
      return `${data.substring(8, 10)}/${data.substring(5, 7)}/${data.substring(
        0,
        4
      )}`;
    case "currency":
      return "$ " + data.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    case "icon":
      return (
        <Icon
          name={entHeader.icon}
          size={entHeader.iconSize ? entHeader.iconSize : "big"}
          onClick = {() => {handleIconclick(entHeader.header, entData)}}
        />
      );
    default:
      return data;
  }
};

export default cellValue;
